








































































































































































































































































































































































































































































































































































































































































































































































































































































































// vue
import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';

// api
import API, { ApiResult } from '@/api/common';
import * as models from '@/class/models/views/setting/workmanage';
import { ICheckBoxListUser } from '@/class/models/typed/user';

// validation
import * as validation from '@/personal/validation';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';

// components
import { ISelectOption } from '@/class/models/typed/wild';
import { strFuzzyMatch } from '@/class/common/util';
import NewVariableInput, {
  INewVariableInput,
} from '@/components/util/NewVariableInput.vue';
import SelectBox from '@/components/util/NewSelectBox.vue';
import CheckBoxList from '@/components/util/CheckBoxList.vue';
import SideBarBase from '@/components/util/SideBarBase.vue';
import { INPUT_TYPE } from '@/components/util/input_type';

// parts
import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import SelectBoxV3, { IOption } from '@/components/util/SelectBoxV3.vue';
import ModalFormDataCheck from '@/components/util/ModalFormDataCheck.vue';
import { CCoreApp, ICoreApp } from '@/class/models/typed/core-app';
import Pagination from '@/parts/app/Pagination.vue';

interface IAppOption extends ISelectOption {
  appChecked: boolean;
  winChecked: boolean;
}

export default Vue.extend({
  name: 'WorkManage',
  components: {
    NewVariableInput,
    VariableInput,
    SelectBox,
    CheckBoxList,
    ModalDeleteConfirm,
    SelectBoxV3,
    SideBarBase,
    ModalFormDataCheck,
    Pagination,
  },
  props: {
    confirmDialog: Function,
    ownerFlag: Boolean,
  },
  watch: {
    mode() {
      this.isProcessing = false;
    },
  },
  data() {
    return {
      onload: false,
      workmanageList: [] as models.IWorkManage[],
      selectedWorkManageID: 1,
      selectedWorkManage: {} as models.IWorkManage,
      editWorkManage: {} as models.IWorkManage,
      editUsers: [] as ICheckBoxListUser[],
      editCoreApps: [] as ICoreApp[],
      selectUsers: [] as ICheckBoxListUser[],
      selectCoreApps: [] as ICoreApp[],
      optionsDepartment: [NOC.SELECT.ALL_DEPARTMENTS] as ISelectOption[],
      searchSideList: '',
      inputedSearchDepartment: 0,
      inputedSearchName: '',
      searchDepartment: 0,
      searchName: '',
      mode: '',
      isDefault: false, // SP初期表示時はdefault:true
      editItems: [
        {
          key: 'name',
          name: '業務管理名',
          placeholder: '業務管理名',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          class: 'col-10',
          max: 40,
        },
      ] as INewVariableInput[],
      appitems: [] as vi.IVariableInput[],
      tableItems: [] as any[],
      tableItemsSP: [] as any[],
      tableFields: [
        { key: 'checked', label: '' },
        { key: 'departmentParent', sortable: true, label: '親部署' },
        { key: 'departmentChild', sortable: true, label: '子部署' },
        { key: 'user', sortable: true, label: '氏名' },
      ] as any[],
      deleteShowFlag: false,
      formDataChangeFlgModal: false,
      compWorkManege: {} as models.IWorkManage,
      compSelectCoreApps: [] as ICoreApp[],
      compEditUsers: [] as ICheckBoxListUser[],
      isProcessing: false, // 二重サブミット防止用
      itemsPerPage: 10,
      viewPages: 1,
      searchWord: '',
    };
  },
  computed: {
    searchDatas(): ICheckBoxListUser[] {
      const lowerKeyword = this.searchWord.toLowerCase();
      return this.selectUsers.filter(item =>
        Object.values(item).some(value => {
          if (typeof value === 'string') {
            return value.toLowerCase().includes(lowerKeyword);
          }
          return false;
        }),
      );
    },
    paginatedDatas(): ICheckBoxListUser[] {
      const start = (this.viewPages - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.searchDatas.slice(start, end);
    },
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_SELECT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.SELECT);
    },
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    MODE_EDIT_BASE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT_BASE);
    },
    MODE_NEW(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW);
    },
    MODE_CHARGE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.CHARGE);
    },
    APP_OPTIONS(): IAppOption[] {
      return [
        {
          value: 0,
          text: 'アプリ・ウィンドウ',
          appChecked: true,
          winChecked: true,
        },
        { value: 1, text: 'アプリ', appChecked: true, winChecked: false },
        { value: 2, text: 'ウィンドウ', appChecked: false, winChecked: true },
      ];
    },
    APP_ITEMS_TEMPLATE(): vi.IVariableInput {
      return {
        key: '0',
        name: '',
        type: 'text',
        placeholder: 'アプリ名',
        required: true,
        error: '',
        max: 255,
        disabled: false,
      };
    },
  },
  // 画面表示時処理
  async mounted() {
    this.mode = NOC.SETTING.MODE.CHARGE;
    this.$emit('pushPath', this.$route.path);
    const query = this.$route.query;
    const api = new API();
    const res = await api.get<models.IWorkManage[]>('workmanage');
    if (res.result) {
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.workmanageList = res.data;
      if (query && query.md) {
        // ハンバーガーメニューから遷移してきた場合、サイドバー(SP)を初期表示する
        this.isDefault = true;
        // URLをクエリなしに書き換え
        this.$router.replace('/setting/work_manage');
      }

      // 先頭の業務管理を初期表示
      if (this.workmanageList.length) {
        // console.log("workmanageList", this.workmanageList);
        await this.onSelectSideList(this.workmanageList[0]);
      }
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }

    // 読み込み完了
    this.onload = true;
  },
  methods: {
    changeView(page: number) {
      this.$data.viewPages = page;
    },
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    getItemID(v: models.IWorkManage) {
      return v.workmanageID;
    },
    getItemText(v: models.IWorkManage) {
      return v.name;
    },
    // サイドバー項目選択処理
    async onSelectSideList(workmanage: models.IWorkManage | null) {
      // console.log("workmanage",workmanage);

      // 新規登録画面と編集画面からも各業務の画面に遷移できるように
      // if (this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)) {
      //   return;
      // }

      this.resetEditData(); // リセット
      if (workmanage) {
        // 基本情報表示
        this.selectedWorkManageID = workmanage.workmanageID;
        // this.selectedWorkManageID = 24;
        this.selectedWorkManage = workmanage;
        this.editCoreApps = [];
        // 対象ユーザーリスト表示
        // console.log("testapi");
        const api = new API();
        // console.log("testapi2");
        const resWorkManage = await api.get<models.VWorkManage>(
          'workmanage/select',
          {
            workmanage_id: this.selectedWorkManageID,
          },
        );
        console.log(resWorkManage);
        if (resWorkManage.result) {
          // console.log("test");
          this.selectedWorkManage = resWorkManage.data.workmanage;
          // console.log("test_select1");
          this.selectUsers = resWorkManage.data.Users;
          // console.log("test_selectUsers");
          this.selectCoreApps = resWorkManage.data.coreApps;
          // console.log("test2", this.selectCoreApps);
        }
      }
      this.mode = NOC.SETTING.MODE.NORMAL;
    },
    // 絞り込むボタン押下時処理
    onClickFilter() {
      this.searchDepartment = this.inputedSearchDepartment;
      this.searchName = this.inputedSearchName;
    },
    filteringUser(row: any, filter: any) {
      // すべての部署以外は親部署・子部署のどちらかにヒットしたら表示
      const matchDepartment =
        !filter.departmentID ||
        row.departmentParentID === filter.departmentID ||
        row.departmentChildID === filter.departmentID;
      return (
        matchDepartment &&
        (!filter.userName || strFuzzyMatch(filter.userName, row.user))
      );
    },
    onCheckUser(data: models.IWorkManageUsedUser, checked: boolean) {
      for (const user of this.editUsers) {
        if (user.userID === data.userID) {
          user.checked = checked;
          break;
        }
      }
    },
    onCheckAllUser(checked: boolean) {
      for (const user of this.editUsers) {
        user.checked = checked;
      }
    },
    // 基本情報の編集ボタン押下時処理
    onClickEditBase() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.EDIT_BASE;
      this.editWorkManage = JSON.parse(JSON.stringify(this.selectedWorkManage));
      this.selectCoreApps.forEach(v => {
        const item = this.addApp();
        Object.assign(item, v);
      });
      // 編集ボタン押下時の業務名を退避
      this.compWorkManege = JSON.parse(JSON.stringify(this.editWorkManage));
      // 編集ボタン押下時の業務扱いを退避
      this.compSelectCoreApps = JSON.parse(JSON.stringify(this.selectCoreApps));
    },
    // 対象ユーザーの編集ボタン押下時処理
    async onClickEditUser() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.EDIT;
      await this.setAllUserList(this.selectedWorkManageID);
      // 編集ボタン押下時のユーザリストを退避
      this.compEditUsers = JSON.parse(JSON.stringify(this.compEditUsers));
      console.log(
        'this.compEditUsers[1].checked',
        this.compEditUsers[1].checked,
      );
    },
    // ユーザーリスト（チェックボックス付き）を設定
    async setAllUserList(workmanageID: number) {
      const api = new API();
      const resUsers = await api.get<models.VWorkManageUsers>(
        'workmanage/users',
        {
          workmanageID,
          isGetAll: true,
        },
      );
      console.log('resUsers', resUsers);
      if (resUsers.result) {
        this.editUsers = resUsers.data.users;
        this.optionsDepartment = [NOC.SELECT.ALL_DEPARTMENTS].concat(
          resUsers.data.departments,
        );
        this.compEditUsers = resUsers.data.users;
      }
      // テーブル表示文字列
      this.tableItems = JSON.parse(JSON.stringify(this.editUsers));
      console.log('tableItems', this.tableItems);
      for (const item of this.tableItems) {
        let user = `${item.sei} ${item.mei}`;
        if (item.mail) {
          user += ` (${item.mail})`;
        }
        item.user = user;
      }
      // テーブル表示文字列(SP)
      this.tableItemsSP = JSON.parse(JSON.stringify(this.editUsers));
      for (const item of this.tableItemsSP) {
        const user = `${item.sei} ${item.mei}`;
        item.user = user;
      }
    },
    // 編集中のデータがあります 基本情報
    formDataChange() {
      let editAppChangeFlg = false;
      let editformDataChangeFlg = false;
      // 編集ボタン押下時の業務名と比較
      if (
        this.editWorkManage.name === this.compWorkManege.name &&
        Boolean(this.editWorkManage.checked) ===
          Boolean(this.compWorkManege.checked)
      ) {
        editformDataChangeFlg = false;
      } else {
        editformDataChangeFlg = true;
      }
      // 編集ボタン押下時の業務扱いと比較
      if (this.editCoreApps.length === this.compSelectCoreApps.length) {
        for (let i = 0; i < this.editCoreApps.length; i++) {
          if (
            Number(this.editCoreApps[i].appID) ===
              Number(this.compSelectCoreApps[i].appID) &&
            this.editCoreApps[i].appName ===
              this.compSelectCoreApps[i].appName &&
            Boolean(this.editCoreApps[i].checked) ===
              Boolean(this.compSelectCoreApps[i].checked) &&
            Boolean(this.editCoreApps[i].appChecked) ===
              Boolean(this.compSelectCoreApps[i].appChecked) &&
            Boolean(this.editCoreApps[i].winChecked) ===
              Boolean(this.compSelectCoreApps[i].winChecked) &&
            // && this.editCoreApps[i].updFlg == this.compSelectCoreApps[i].updFlg
            // updFlgは初期値からtrueになっているものがあり、差異の比較に使用できなかった。他の項目でチェックだけで差異は確認できるので使用しない。
            // 不具合一覧に記載している。
            !this.editCoreApps[i].delFlg
          ) {
            editAppChangeFlg = false;
          } else {
            editAppChangeFlg = true;
            break;
          }
        }
      } else {
        editAppChangeFlg = true;
      }
      if (editformDataChangeFlg || editAppChangeFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    // 編集中のデータがあります 対象ユーザー
    formDataUserChange() {
      let editUsersFlg = false;
      // 編集ボタン押下時の対象ユーザーと比較
      for (let i = 0; i < this.compEditUsers.length; i++) {
        if (
          Boolean(this.tableItems[i].checked) ===
            Boolean(this.compEditUsers[i].checked) &&
          Boolean(this.tableItemsSP[i].checked) ===
            Boolean(this.compEditUsers[i].checked)
        ) {
          editUsersFlg = false;
        } else {
          editUsersFlg = true;
          break;
        }
      }
      if (editUsersFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    // 戻る
    selectBack() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.NORMAL;
      // this.isDefault = true;
      this.resetEditData();
    },
    // サイドバーへ戻る
    selectBackMenu() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.isDefault = true;
      this.resetEditData();
    },
    // 次へからの戻る
    selectBackToNew() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.NEW;
    },
    // 業務管理を追加
    async addWorkManage() {
      this.mode = NOC.SETTING.MODE.NEW;
      this.editWorkManage = new models.CWorkManage();
      this.compWorkManege = new models.CWorkManage();
      this.appitems = [];
      this.editCoreApps = [];
      this.compSelectCoreApps = [];
    },
    // 次へクリック時
    async onClickNext() {
      window.scrollTo(0, 0);

      const editCoreAppsArry = this.editCoreApps.map(v => v.appName);
      const workManageErrorFlag = !validation.checkValues(
        this.editWorkManage,
        this.editItems,
      );
      const coreAppsErrorFlag = !validation.checkValues(
        editCoreAppsArry,
        this.appitems,
      );

      // 入力エラーが無ければ次へ
      if (workManageErrorFlag && coreAppsErrorFlag) {
        this.mode = NOC.SETTING.MODE.SELECT;
        await this.setAllUserList(0); // チェックボックスの選択なし
      }
    },
    // 削除するクリック時
    openDeleteWorkManage() {
      this.deleteShowFlag = true;
    },
    // 削除モーダルクローズ
    closeModal() {
      this.deleteShowFlag = false;
    },
    // 業務管理の削除実行
    async deleteWorkManage() {
      const api = new API();
      const res = await api.delete<models.VWorkManage>('workmanage/delete', {
        deleteID: this.selectedWorkManageID,
      });
      if (!res.result) {
        this.$emit('info', '削除できませんでした。');
      } else {
        await this.processAfterUpdate(res);
      }
      if (this.workmanageList.length > 0) {
        this.selectedWorkManageID = this.workmanageList[0].workmanageID;
      }
      this.isDefault = true;
    },
    // 基本情報の更新ボタン押下時処理
    async onClickRegistBase() {
      window.scrollTo(0, 0);
      // validation
      // if (validation.checkValues(this.editWorkManage, this.editItems)) {
      //   return false;
      // }
      const editCoreAppsArry = this.editCoreApps.map(v => v.appName);
      const workManageErrorFlag = !validation.checkValues(
        this.editWorkManage,
        this.editItems,
      );
      const coreAppsErrorFlag = !validation.checkValues(
        editCoreAppsArry,
        this.appitems,
      );
      if (!workManageErrorFlag || !coreAppsErrorFlag) {
        return false;
      }

      // 値を設定
      const requestData: models.VWorkManage = {
        workmanage: this.editWorkManage,
        coreApps: this.editCoreApps,
        Users: [],
        workmanageList: [],
      };
      // 登録実行
      const api = new API();
      const res = await api.put<models.VWorkManage, models.VWorkManage>(
        'workmanage/edit/info',
        requestData,
      );
      await this.processAfterUpdate(res);
      console.log('requestData', requestData);
    },
    // 対象ユーザーの更新ボタン押下時処理
    async onClickRegistUser() {
      window.scrollTo(0, 0);
      // 値を設定
      const requestData: models.VEditWorkManageInfo = {
        workmanage: this.selectedWorkManage, // this.editGroup,
        userIDs: this.editUsers.filter(v => v.checked).map(v => v.userID),
        coreApps: [],
      };
      // 登録実行
      const api = new API();
      const res = await api.put<models.VEditWorkManageInfo, models.VWorkManage>(
        'workmanage/edit/users',
        requestData,
      );
      await this.processAfterUpdate(res);
      console.log('requestData', requestData);
    },
    // 対象ユーザーの決定ボタン押下時処理
    async onClickRegistNew() {
      window.scrollTo(0, 0);
      const registCoreApps = this.editCoreApps.filter(v => {
        return !v.delFlg;
      });
      // 値を設定
      console.log('editCoreApps', this.editCoreApps);
      const requestData: models.VEditWorkManageInfo = {
        workmanage: this.editWorkManage,
        userIDs: this.editUsers.filter(v => v.checked).map(v => v.userID),
        coreApps: registCoreApps,
      };
      // 登録実行
      const api = new API();
      this.isProcessing = true;
      const res = await api.post<
        models.VEditWorkManageInfo,
        models.VWorkManage
      >('workmanage/new', requestData);
      // await this.processAfterUpdate(res);
      this.newSelectedWork(res);
    },
    // 更新後の後処理
    async processAfterUpdate(res: ApiResult<models.VWorkManage>) {
      if (res.result) {
        this.mode = NOC.SETTING.MODE.NORMAL;
        this.workmanageList = res.data.workmanageList;
        // 選択中の業務を再表示
        if (this.workmanageList.length) {
          this.selectedWorkManageID = this.selectedWorkManage.workmanageID;
          let selected;
          selected = this.workmanageList.find(
            v => v.workmanageID === this.selectedWorkManageID,
          );
          // console.log("selected", selected);
          if (!selected) {
            // 業務管理削除後
            if (this.workmanageList.length > 0) {
              // 1件以上あれば最初の業務管理を表示
              selected = this.workmanageList[0];
            } else {
              // 0件なら何も表示しない
              selected = null;
            }
          }
          this.onSelectSideList(selected);
        }
        // this.onSelectSideList(res.data.workmanage);
      } else {
        this.$emit('info', '登録できませんでした。');
      }
    },
    // 新規登録した業務を表示する処理
    newSelectedWork(res: ApiResult<models.VWorkManage>) {
      if (res.result) {
        this.mode = NOC.SETTING.MODE.NORMAL;
        this.workmanageList = res.data.workmanageList;
        const work = this.workmanageList.find(
          v => v.workmanageID === res.data.workmanage.workmanageID,
        );
        if (work) {
          this.onSelectSideList(work);
          this.mode = NOC.SETTING.MODE.SELECT;
        } else {
          this.mode = NOC.SETTING.MODE.NORMAL;
        }
      } else {
        this.$emit('info', '登録できませんでした。');
        this.isProcessing = false;
      }
    },
    // 編集データ破棄
    resetEditData() {
      this.editWorkManage = new models.CWorkManage();
      this.editUsers = [];
      this.editCoreApps = [];
      this.optionsDepartment = [NOC.SELECT.ALL_DEPARTMENTS];
      this.searchDepartment = 0;
      this.searchName = '';
      this.inputedSearchDepartment = 0;
      this.inputedSearchName = '';
    },
    getAppName(value: string) {
      const result = this.APP_OPTIONS.find(v => String(v.value) === value);
      return result ? result.text : '';
    },
    getAppType(item: ICoreApp) {
      if (!item) {
        return '0';
      }
      const result = this.APP_OPTIONS.find(
        v =>
          Number(v.appChecked) === Number(item.appChecked) &&
          Number(v.winChecked) === Number(item.winChecked),
      );
      return result ? String(result.value) : '0';
    },
    addApp(): ICoreApp {
      const newItem = new CCoreApp();
      // init
      newItem.appChecked = true;
      newItem.winChecked = true;
      // values
      this.editCoreApps.push(newItem);
      // validations
      const item = { ...this.APP_ITEMS_TEMPLATE }; // copy
      item.key = String(this.editCoreApps.length - 1);
      // item.disabled = !this.editAlertData.bannedappChecked;
      this.appitems.push(item);
      return newItem;
    },
    onSelectWorkManageType(item: CCoreApp, value: string) {
      const result = this.APP_OPTIONS.find(v => String(v.value) === value);
      if (result) {
        item.appChecked = result.appChecked;
        item.winChecked = result.winChecked;
      }
    },
    onChangeWorkManage(idx: number) {
      // 入力部品設定
      const editedApp = this.editCoreApps[idx];
      const item = this.appitems[idx];
      item.error = '';
      editedApp.updFlg = editedApp.appID ? true : false;
    },
    onClickDeleteApp(idx: number) {
      const editedApp = this.editCoreApps[idx];
      const item = this.appitems[idx];
      item.error = '';
      item.required = false;
      editedApp.delFlg = true;
    },
    onClickClose() {
      this.$emit('close');
    },
    onClickCancel() {
      this.$emit('close');
    },
  },
});
